var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.656,
    height: 17,
    viewBox: "0 0 14.656 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "User",
    d: "M-2356.959-218.415a5.8,5.8,0,0,0-5.8-5.8,5.8,5.8,0,0,0-5.8,5.8h-1.031a6.836,6.836,0,0,1,6.828-6.829,6.836,6.836,0,0,1,6.828,6.829Zm-9.9-11.877a4.128,4.128,0,0,1,4.123-4.123,4.127,4.127,0,0,1,4.123,4.123,4.127,4.127,0,0,1-4.123,4.123A4.128,4.128,0,0,1-2366.858-230.292Zm1.031,0a3.1,3.1,0,0,0,3.093,3.092,3.1,3.1,0,0,0,3.093-3.092,3.1,3.1,0,0,0-3.093-3.092A3.1,3.1,0,0,0-2365.827-230.292Z",
    transform: "translate(2370.086 234.915)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.d80690ff892b3de1d08bf169096048ba.svg";
export { ForwardRef as ReactComponent };